// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import Vant from "vant";
import "vant/lib/index.css";
import "@/assets/css/resetui.css";
import "amfe-flexible";
// axios封装
import { post, fetch, patch, put } from "./utils/request";
import {
  Lazyload,
  Overlay,
  Button,
  Field,
  Form,
  Checkbox,
  Popup,
  Area,
  Loading,
  ActionSheet,
  Tag,
  Icon,
  CountDown,
  Swipe,
  SwipeItem,
  Uploader,
  Sticky,
  Dialog,
} from "vant"; // 引入
import storage from "@/utils/storage.js";
import global from "@/utils/global";
import Vuex from "vuex";
import store from "./store";

Vue.prototype.global = global;
Vue.prototype.$storage = storage;

Vue.use(Vuex);
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.use(Overlay);
Vue.use(Button);
Vue.use(Field);
Vue.use(Form);
Vue.use(Checkbox);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Loading);
Vue.use(ActionSheet);
Vue.use(Tag);
Vue.use(Icon);
Vue.use(CountDown);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Uploader);
Vue.use(Sticky);
Vue.use(Dialog);

// 定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  window.document.title =
    to.meta.title == undefined ? "看短剧抽红包" : to.meta.title;
  if (to.path.includes("temInit") && to.path !== "/temInit") {
    next({ path: "/temInit", query: to.query }); // 保留query参数
  } else {
    next();
  }
});

// 路由变化跳转页面回到顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

/* eslint-disable no-new */
// new Vue({
//   el: "#app",
//   store,
//   router,
//   components: { App },
//   template: "<App/>"
// });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js